/* eslint-disable */

import config from 'config'

/**
 *
 *
 * @export
 * @class Api
 */
class Api {
  /**
   * Creates an instance of Api.
   * @param {*} baseUri
   * @param {*} redirectUri - app whose /auth/sso should be hit on a 401 (defaults to ss_api_sales)
   * @memberof Api
   */
  constructor(baseUri, redirectUri = config.redirectUri) {
    this.baseUri = baseUri
    this.redirectUri = redirectUri
  }

  /**
   * Makes a redirect to the SSO if err status is 401, returns a Promise.reject
   *
   * @param {*} err
   * @returns {Promise<Response>}
   * @memberof Api
   */
  _handleError(err: any): Promise<Response> {
    if (err.status === 401) {
      sessionStorage.removeItem('auth')
      window.location = `${this.redirectUri}/auth/sso?origin=${
        window.location.href
      }`
      return Promise.reject()
    }
    return Promise.reject(err)
  }

  /**
   * Makes an api request, handles error status 401
   *
   * @param {string} endpoint - the endpoint, that gets appended to the (default) baseUri
   * @param {?Object} [options={}] - custom request options, override default ones
   * @param {?string} baseUri - custom baseUri
   * @returns {Promise<any>}
   * @memberof Api
   */
  request(
    endpoint: string,
    options: ?Object = {},
    baseUri: ?string,
  ): Promise<any> {
    const BASE_URI: string = baseUri || this.baseUri

    const request = new Request(`${BASE_URI}${endpoint}`, {
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      credentials: 'include',
      ...options,
    })

    return fetch(request)
      .then((r) => {
        return options.blob ? r.blob() : r.status <= 200 ? r.json() : Promise.reject(r)
      })
      .catch(this._handleError.bind(this))
  }
}

const api = new Api(config.baseUri)

export const partnerApi = new Api(
  `${config.partnerUri}/api/v2`,
  config.partnerUri,
)

export default api
